import { render, staticRenderFns } from "./the-navigation-accordion-shell.vue?vue&type=template&id=c4eeee3e&"
import script from "./the-navigation-accordion-shell.vue?vue&type=script&lang=js&"
export * from "./the-navigation-accordion-shell.vue?vue&type=script&lang=js&"
import style0 from "./the-navigation-accordion-shell.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports